<template>
  <kst-section items-mode>
    <kst-table view-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        field="DispatchName"
        :label="RtnInvoiceItemCatalog.DispatchName.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="RtnInvoiceItemCatalog"/>
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.getItemInfo_Related(row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-packaging"
        field="Packaging"
        :label="RtnInvoiceItemCatalog.Packaging.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="RtnInvoiceItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-qty"
        field="Quantity"
        :label="RtnInvoiceItemCatalog.Quantity.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="RtnInvoiceItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="SellPrice"
        :label="RtnInvoiceItemCatalog.SellPrice.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="RtnInvoiceItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-subtotal"
        field="Total"
        :label="RtnInvoiceItemCatalog.Total.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="RtnInvoiceItemCatalog"/>
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import RtnInvoiceItemCatalog from "../RtnInvoiceItemCatalog.js";
import Model from "../RtnInvoiceModel.js";

export default {
  props: {
    items: Array
  },
  data: () => ({
    RtnInvoiceItemCatalog: RtnInvoiceItemCatalog,
    Model: Model
  })
}
</script>